<script>
import {ref} from 'vue';
import {useMenuStore} from '@/js/store/MenuStore.js';
import IconChevronDown from '@js/components/Icons/IconChevronDown.vue';
import IconX from '@js/components/Icons/IconX.vue';
import {Link} from '@inertiajs/vue3';
import MobileMenuDropdownBlock from '@js/components/Mobile/Components/MobileMenuDropdownBlock.vue';
import SalesDepartmentPhone from '@js/components/Sections/Links/SalesDepartmentPhone.vue';
import IconLogo from '@js/components/Icons/IconLogo.vue';
import {useLikeStore} from "@js/store/LikeStore.js";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import IconHeart from "@js/components/Icons/IconHeart.vue";
import {useCompareStore} from "@js/store/CompareStore.js";
import ImageLoader from "@js/components/Loaders/ImageLoader.vue";

export default {
    name: 'MobileMenu',
    components: {
        ImageLoader,
        IconHeart,
        IconAngleLeft,
        IconLogo,
        SalesDepartmentPhone,
        MobileMenuDropdownBlock,
        IconX,
        IconChevronDown,
        Link,
    },
    setup() {
        const menuStore = useMenuStore()
        const likeStore = useLikeStore()
        const compareStore = useCompareStore()

        // координата начала касания
        const touchStartX = ref(0);
        // смещение по X
        const touchDeltaX = ref(0);

        const onTouchStart = (e) => {
            touchStartX.value = e.touches[0].clientX;
        };

        const onTouchMove = (e) => {
            touchDeltaX.value = e.touches[0].clientX - touchStartX.value;
        };

        const onTouchEnd = () => {
            // если свайп влево более чем на 50px — закрываем меню
            if (touchDeltaX.value < -50) {
                menuStore.toggleSidenav();
            }
            touchDeltaX.value = 0;
        };

        return {
            menuStore,
            likeStore,
            compareStore,
            onTouchStart,
            onTouchMove,
            onTouchEnd,
        };
    },
};
</script>

<template>
    <div>
        <div @touchstart.passive="onTouchStart"
             @touchmove.passive="onTouchMove"
             @touchend="onTouchEnd"
             class="fixed inset-y-0 left-0 z-50 w-full max-w-[480px] bg-white shadow-xl transform transition-transform duration-300"
             :class="{ '-translate-x-full': !menuStore.isSidenavOpen, 'translate-x-0': menuStore.isSidenavOpen }">
            <!-- содержимое меню -->
            <div class="flex flex-col h-full">
                <div class="flex items-center justify-between py-3 px-4 shadow">
                    <IconLogo class="h-auto w-[200px]"/>
                    <button @click.prevent="menuStore.toggleSidenav" title="Закрыть" aria-label="Закрыть"
                            class="rounded-md focus:outline-none">
                        <IconX class="w-6 h-6"/>
                    </button>
                </div>
                <nav class="flex-grow overflow-y-auto max-h-full px-4">
<!--                    <div class="grid grid-cols-2 divide-x divide-gray-500 mb-2">-->
<!--                        <div class="flex items-center justify-center">-->
<!--                            <Link :href="route('likedProducts')" class="flex gap-2 font-medium">-->
<!--                                <IconHeart class="w-5 h-5 text-navHoverColor"/>-->
<!--                                Избранные ({{ likeStore.likedIds.length ?? 0 }})-->
<!--                            </Link>-->
<!--                        </div>-->
<!--                        <div class="flex items-center justify-center">-->
<!--                            <Link :href="route('compareProducts')" class="flex gap-2 font-medium">-->
<!--                                <IconScales class="w-5 h-5 text-blue-500"/>-->
<!--                                Сравнение ({{ compareStore.comparedIds.length ?? 0 }})-->
<!--                            </Link>-->
<!--                        </div>-->
<!--                    </div>-->
                    <ul>
                        <template v-for="(menuItem, itemKey) in menuStore.menuItems" :key="itemKey">
                            <li class="flex items-start border-b py-2 gap-3">
                                <div class="rounded-lg border min-h-[40px] min-w-[40px] w-[40px] h-[40px] overflow-hidden">
                                    <img alt="" aria-hidden="true" role="presentation"
                                         :src="`/storage/category_icons/${menuItem.route_params.category_title}.webp`"
                                         class="h-full h-full object-cover"/>
                                </div>

                                <div v-if="menuItem.sub_menu && menuItem.sub_menu.length" class="w-full">
                                    <MobileMenuDropdownBlock
                                        :route_name="menuItem.route_name"
                                        :route_params="menuItem.route_params"
                                        :btnText="menuItem.title" :items="menuItem.sub_menu"/>
                                </div>
                                <div v-else class="w-full">
                                    <Link :href="route(menuItem.route_name, menuItem.route_params ?? {})"
                                          class="flex items-center py-2 text-base font-medium text-gray-900 rounded-lg group">
                                        <span>
                                            {{ menuItem.title }}
                                        </span>
                                    </Link>
                                </div>
                            </li>
                        </template>
                    </ul>
                </nav>
                <!--                <div class="mt-auto">-->
                <!--                    <div class="flex flex-col items-center justify-center">-->
                <!--                        <div class="w-full ps-4">-->
                <!--                          -->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>

        <!-- Overlay -->
        <div
            v-if="menuStore.isSidenavOpen"
            @click.prevent="menuStore.toggleSidenav"
            class="fixed inset-0 bg-black bg-opacity-50 z-40"
        ></div>
    </div>
</template>
